import { render } from "./DirectoryModal.vue?vue&type=template&id=6228fa1c"
import script from "./DirectoryModal.vue?vue&type=script&lang=js"
export * from "./DirectoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__